MOVE.MEDIA = (function (MOVE) {
  'use strict';

  MOVE.MEDIA =
  {
  };

  return MOVE.MEDIA;
})(MOVE || {});



// WEBPACK FOOTER //
// ./consumer_media/consumer_media.js